










































import { Component, Vue } from "vue-property-decorator";

@Component
export default class FilesDuplicatesModal extends Vue {
    files = [] as string[];

    open(duplicates: string[], notAllowed: boolean) {
        this.files = duplicates;
        if (notAllowed) {
            this.$bvModal.show("modal-duplicates-not-allowed");
        } else {
            this.$bvModal.show("modal-duplicates");
        }
    }

    decline() {
        this.$bvModal.hide("modal-duplicates");
        this.files = [] as string[];
    }

    confirm() {
        this.$bvModal.hide("modal-duplicates");
        this.files = [] as string[];
        this.$emit("confirm");
    }
}
